export const SubmitTastingStep = {
    selectTasting: "selectTasting",
    selectTastingProducts: "selectTastingProducts",
    selectCiders: "selectCiders",
    confirmCiders: "confirmCiders",
    checkoutSummary: "checkoutSummary",
    checkoutCompleted: "checkoutCompleted"
}